module.exports = __webpack_public_path__ + "static/media/account-img.c14db022.jpeg";